import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs as Tabs$1 } from '@zillow/constellation';
import { triggerTabClickEvent, CustomPropTypes } from '@zillow/zrs-cms';
import { generateBlockList } from '../components/BlockList/BlockList.js';

var HtmlToReact = require('html-to-react');
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();
var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
var processingInstructions = [{
  shouldProcessNode: function shouldProcessNode() {
    return true;
  },
  processNode: processNodeDefinitions.processDefaultNode
}];
var TabsBlock = function TabsBlock(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var tabs = [];
  var panels = [];
  innerBlocks.forEach(function (innerBlock) {
    var tabId = innerBlock.attrs.tabId;
    tabs.push( /*#__PURE__*/React.createElement(Tabs$1.Tab, {
      key: tabId,
      id: tabId
    }, htmlToReactParser.parseWithInstructions(innerBlock.attrs.label, function () {
      return true;
    }, processingInstructions)));
    panels.push( /*#__PURE__*/React.createElement(Tabs$1.Panel, {
      key: tabId,
      "aria-labelledby": tabId,
      id: innerBlock.attrs.id
    }, generateBlockList({
      blocks: innerBlock.innerBlocks
    })));
  });
  var _useState = useState(
    // Start with defaultSelected tab otherwise the first tab. There will always be a first
    // tab because if the user removes the last tab in the editor, it removes the parent
    // "tabs" block.
    attrs.defaultSelectedId || innerBlocks[0].attrs.tabId),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTabId = _useState2[0],
    setSelectedTabId = _useState2[1];
  return /*#__PURE__*/React.createElement(Tabs$1, {
    key: index,
    fluid: attrs.fluid,
    selected: selectedTabId,
    onSelected: function onSelected(tabId) {
      setSelectedTabId(tabId);
      var tabInnerBlock = innerBlocks.find(function (innerBlock) {
        return innerBlock.attrs.tabId === tabId;
      });
      if (!tabInnerBlock) {
        throw new Error("Could not find tab for tabId of \"" + tabId + "\"");
      }
      triggerTabClickEvent({
        id: tabInnerBlock.attrs.id,
        label: tabInnerBlock.attrs.label
      });
    },
    id: attrs.id
  }, /*#__PURE__*/React.createElement(Tabs$1.List, {
    justifyContent: attrs.justifyContent
  }, tabs), /*#__PURE__*/React.createElement(Tabs$1.Panels, null, panels));
};
TabsBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    attrs: PropTypes.shape({
      tabId: PropTypes.string.isRequired,
      label: PropTypes.string
    })
  })),
  attrs: PropTypes.shape({
    appearance: PropTypes.string.isRequired,
    defaultSelectedId: PropTypes.string,
    fluid: CustomPropTypes.inlineMediaQuery(PropTypes.bool).isRequired,
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['center', 'flex-start', 'flex-end']))
  }),
  index: PropTypes.number
} : {};
var Tabs = TabsBlock;

export { Tabs as default };
